import React from 'react';

// Custom minimalist industrial thin-line icons.
const paths = {
  excavation: (
    <>
      <path d='M3 20h18' />
      <path d='M4 20v-4h5v4' />
      <path d='M9 16l3-6 6 3' />
      <path d='M12 10l4-3' />
      <circle cx='17' cy='7' r='1.4' />
    </>
  ),
  filling: (
    <>
      <path d='M3 21h18' />
      <path d='M6 21l3-7h6l3 7' />
      <path d='M12 3v6' />
      <path d='M9 6l3 3 3-3' />
    </>
  ),
  footing: (
    <>
      <path d='M3 8h18' />
      <path d='M6 8v10M12 8v10M18 8v10' />
      <path d='M4 18h16' />
      <path d='M8 4l4 4 4-4' />
    </>
  ),
  demolition: (
    <>
      <path d='M3 21h18' />
      <path d='M6 21V9l6-3v15' />
      <path d='M12 12l6 2v7' />
      <path d='M15 3l2 3-3 1' />
    </>
  ),
  rockcutting: (
    <>
      <path d='M4 20l6-10 4 3 6-8' />
      <path d='M4 20h7' />
      <circle cx='20' cy='5' r='1.4' />
      <path d='M10 10l2.5 1.8' />
    </>
  ),
  dewatering: (
    <>
      <path d='M12 3c3 4 5 6.5 5 9a5 5 0 0 1-10 0c0-2.5 2-5 5-9z' />
      <path d='M9.5 13a2.5 2.5 0 0 0 2.5 2.5' />
    </>
  ),
  blasting: (
    <>
      <path d='M12 12l0-8M12 12l6-4M12 12l7 2M12 12l-6-4M12 12l-7 2M12 12l4 6M12 12l-4 6' />
      <circle cx='12' cy='12' r='1.6' />
    </>
  ),
  chemical: (
    <>
      <path d='M9 3h6' />
      <path d='M10 3v6l-4 8a2 2 0 0 0 1.8 3h8.4a2 2 0 0 0 1.8-3l-4-8V3' />
      <path d='M7.5 15h9' />
    </>
  ),
  labour: (
    <>
      <circle cx='12' cy='6' r='2.4' />
      <path d='M6 3.5c1.5-1 3-1 6 0M8 8.3V6' />
      <path d='M5 21v-4a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v4' />
    </>
  ),
  hiring: (
    <>
      <path d='M3 17h13v-5H8l-2 3H3z' />
      <circle cx='7' cy='19' r='1.6' />
      <circle cx='15' cy='19' r='1.6' />
      <path d='M16 12l3-4h2v9' />
    </>
  ),
  drill: (
    <>
      <path d='M6 3h9v5H6z' />
      <path d='M15 5h3v2h-3' />
      <path d='M9 8v3M12 8v6' />
      <path d='M10 20l2-4 2 4z' />
    </>
  ),
  truck: (
    <>
      <path d='M2 16V6h11v10' />
      <path d='M13 9h4l4 4v3h-8' />
      <circle cx='7' cy='18' r='2' />
      <circle cx='17' cy='18' r='2' />
    </>
  ),
  dozer: (
    <>
      <path d='M3 18h11v-5H6l-3 2z' />
      <path d='M14 13h3l3 3v2h-6' />
      <circle cx='7' cy='19' r='1.6' />
      <circle cx='16' cy='19' r='1.6' />
      <path d='M20 8v8' />
    </>
  ),
  layers: (
    <>
      <path d='M12 3l9 5-9 5-9-5 9-5z' />
      <path d='M3 13l9 5 9-5' />
    </>
  ),
  steel: (
    <>
      <path d='M4 4h16v4H4zM4 16h16v4H4z' />
      <path d='M6 8l4 8M14 8l4 8M10 8l4 8' />
    </>
  ),
  arrow: (
    <>
      <path d='M5 12h14' />
      <path d='M13 6l6 6-6 6' />
    </>
  ),
  arrowDown: (
    <>
      <path d='M12 5v14' />
      <path d='M6 13l6 6 6-6' />
    </>
  ),
};

export const Icon = ({ name, size = 24, strokeWidth = 1.5, className = '' }) => {
  const content = paths[name] || paths.layers;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      aria-hidden='true'
      focusable='false'
    >
      {content}
    </svg>
  );
};
